module.exports = __webpack_public_path__ + "img/warning-confirmation-icon.4f1cfda5.png";